import React, { useEffect, useState } from 'react'
import VisionGuard from './VisionGuard'
import { hasVisionMark } from './visionMark'
import { subscribeVisionSignals, wasWorkstationCoveredReported } from './visionSignals'

/**
 * Story 213 — S142 (construction gap C-1). MainContainer mounts this while the user is not loaded yet.
 * Reloading MIC with the screen covered sends the start-up requests (user/details, language) to Sun,
 * which answers 423 because they are outside the allow-list: they never settle and the app shell, with
 * its guard, would never mount. So the guard mounts here, with the mark or with that 423, and only talks
 * to vision/session and vision/frame. Without either, it renders nothing and asks nothing (CA10).
 */
const VisionStartupGuard = () => {
  const [coveredOnStartUp, setCoveredOnStartUp] = useState(wasWorkstationCoveredReported)
  const [watched] = useState(hasVisionMark)

  useEffect(() => subscribeVisionSignals((signal) => {
    if (signal === 'covered') {
      setCoveredOnStartUp(true)
    }
  }), [])

  if (coveredOnStartUp) {
    // `key` restarts the guard covered when a mark-only one had mounted first.
    return <VisionGuard key='covered' startCovered reloadWhenUncovered />
  }
  if (watched) {
    return <VisionGuard key='watched' />
  }
  return null
}

export default VisionStartupGuard
